<template>
  <div :class="['datebutton', props.isSelected ? 'active' : '']">
    <span class="text-slate-500 text-xl font-semibold">{{ mainText }}</span>
    <span class="text-slate-400">{{ secondaryText }}</span>
    <span class="text-slate-400">{{ tertiaryText }}</span>
  </div>
</template>

<script setup>
import { defineProps} from 'vue'

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  mainText: {
    type: String,
    required: true
  },
  secondaryText: {
    type: String
  },
  tertiaryText: {
    type: String
  },
  isSelected: {
    type: Boolean,
  }
})
</script>

<style scoped lang="scss">
.datebutton {
  @apply border border-slate-300 bg-gray-100 cursor-pointer p-4 flex flex-col rounded-md select-none;
  &.active {
    @apply bg-gray-300;
  }
}
</style>